module.exports = __webpack_public_path__ + "static/media/project-diagram.a14d09ca.svg";